import { CompanyBuilder, CompanySettings } from '../companies.types';

export const getCompanySettings = (builder: CompanyBuilder) =>
  builder.query<CompanySettings, number>({
    query: (companyId) => ({
      url: `/companies/${companyId}/settings`,
      method: 'GET',
    }),
    providesTags: (_result, _error, companyId) => [
      { type: 'Company', id: `settings-${companyId}` },
    ],
  });
